<h1 class="capitalize">{{dataType ? dataType.split('/')[0].slice(0, -1) : ""}} Search</h1>

<app-search 
    [pagingModel]="pagingModel"
    [showInDialog]="showInDialog"
    [columnData]="columnDataResult"
    (dataViewUpdate)="queryData($event)" 
    [selectedSearchArea]="selectedSearchArea" 
    [searchKeyword]="searchKeyword"
    (cancelEvent)="handleCancel()"
    />
